export const modalMixin = {
  computed: {
    showModal () {
      return this.$store.state.modalModule.active
    },
    content () {
      return this.$store.state.modalModule.content
    },
    playlistItems () {
      return this.$store.state.modalModule.playlist
    }
  }
}